'use client'

// Re-export from shared auth package
export { useClientSession } from '@shared/auth/client';